import api from "@/lib/api";

// CREATE
export const createAnnouncement = async (payload) => {
  const res = await api.post("/announcements/create", payload);
  return res.data;
};

// GET ALL
export const getAllAnnouncements = async () => {
  const res = await api.get("/announcements/all");
  return res.data;
};

// GET BY ID
export const getAnnouncementById = async (announcement_id) => {
  const res = await api.get(`/announcements/${announcement_id}`);
  return res.data;
};

// DELETE
export const deleteAnnouncement = async (announcement_id) => {
  const res = await api.post(`/announcements/delete/${announcement_id}`);
  return res.data;
};

// UPDATE (add this when backend supports it)
export const updateAnnouncement = async (payload) => {
  const res = await api.post("/announcements/update", payload);
  return res.data;
};